module.exports = __webpack_public_path__ + "img/banner06m.0cdbac47.png";